class CartDrawer extends HTMLElement {
  constructor() {
    super();
   this.count = 0;
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

   open(triggeredBy) {
    console.log("cart drawer is triggered");
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    document.body.classList.add("overflow-hidden");
    // added for the recipe page back button
    document.body.classList.add("cart-drawer-active");
    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    // added for the recipe page back button
    document.body.classList.remove("cart-drawer-active");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    console.log("render content from cart drawer.js", parsedState);

    // Helper function to check if it's the first add within 24 hours
    const isFirstAddToday = () => {
        return !document.cookie.split(';').some(cookie => 
            cookie.trim().startsWith('firstAddShown='));
    };

    // Helper function to set the cookie
    const setFirstAddCookie = () => {
        const date = new Date();
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); // 24 hours
        document.cookie = `firstAddShown=true; expires=${date.toUTCString()}; path=/`;
    };

    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
        this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
        
        if (parsedState.sections != null) {
            console.log("parsed state is not null");
            sectionElement.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
            );
        }

        if (section.id == "cart-icon-bubble") {
            var cartCountBubble = sectionElement.querySelector(
                ".cart-count-bubble span:first-child"
            );
            if (cartCountBubble) {
                $(".cart-count-bubble").removeClass("hidden");
                var itemCount = cartCountBubble.innerText;
                $(".header__icons").find(".cart-count-bubble span").text(itemCount);
            }
        }
    });

    if (parsedState.sections != null) {
        setTimeout(() => {
            this.querySelector("#CartDrawer-Overlay").addEventListener(
                "click",
                this.close.bind(this)
            );

            if (isFirstAddToday()) {
                // First add within 24 hours - show drawer and set cookie
                this.open();
                setFirstAddCookie();
            } else {
                // Not first add - show toaster
                this.showItemAddeToaster();
            }
        });
    }
}
  // show toaster
  showItemAddeToaster(){
      toastr.success('Item added to cart')
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
